<template>
  <section class="inspection-section">
    <h2 class="page-header__big-text-line">
      진단 결과를 확인해 보세요
    </h2>
    <figure class="inspection-list__phone" style="margin-top:24px; border-top-right-radius: 8px; border-top-left-radius: 8px;" v-if="resInfo.rsn_ctt == ''">
      <img v-bind:src="`${this.resInfo.img_url}`" onerror="this.onerror=null; 
        this.src='https://www.mintit.co.kr/assets/images/img/price-device-normal.png';">
      <!-- <img src="/static/images/test_phone.png" alt=""> -->
      <ul>
        <li class="inspection-list__phone-text-left">
          <h5>모델명</h5>
          <h4>{{ resInfo.ptnm_nm }}</h4>
        </li>
        <li class="inspection-list__phone-text-right">
          <h2>{{ resInfo.total_price }}원</h2>
          <h6>최종 판매금액</h6>
        </li>
      </ul>   
    </figure>
    <figure class="inspection-list__phone" style="margin-top:24px; border-top-right-radius: 8px; border-top-left-radius: 8px;" v-if="resInfo.rsn_ctt != ''">
        <dl class="inspection-list__result-list2" style="width:100%;">
          <dt style="font-size:16px; font-weight:500;" >최종 판매금액</dt>
          <dd style="font-size:24px; font-weight:800;">1,000원</dd>
        </dl> 
    </figure>
    <article class="inspection-list__result2" style="">
        <div class="divider" v-if="resInfo.add_cmp_amt > 0"></div>
        <dl class="inspection-list__result-list2" style="margin-top:8px;"  v-if="resInfo.add_cmp_amt > 0">
          <dt style="margin-left:4px; font-weight:700; color:#333333;">평가금액</dt>
          <dd style="margin-right:4px; font-weight:400; color:#5F5F5F;">{{ resInfo.gd_price }}원</dd>
        </dl>
        <dl class="inspection-list__result-list2" v-if="resInfo.add_cmp_amt > 0" v-for="item in resInfo.add_cmp_amt_list">
          <dt style="margin-left:4px; font-weight:800; color:#05977D;">{{ item.atm_display_price_name }}</dt>
          <dd style="margin-right:4px; font-weight:400; color:#5F5F5F;">{{ item.add_cmp_amt }}원</dd>
        </dl> 
        <div style="text-align: center; margin-top:15px; margin-bottom:10px; color:#8B8B8B;" v-if="resInfo.add_cmp_amt > 0">
	    	<img src="@/assets/images/icon-small-notice-all.svg" width="6%" height="6%" style="position:relative; left: 1%; bottom:-5.2px;" alt="">
		    {{resInfo.atm_display_popup_titles}} 대상자 입니다
    	</div> 
    </article>
     
	<article class="inspection-list__result3" style="" v-if="resInfo.spsl_amt != '0' && resInfo.add_cmp_amt ==0">
        <div style= "font-size: 16px; line-height: 20px; font-weight: 700; color: #EE50F6; margin-bottom:14px;">
        	<img src="@/assets/images/home_check.svg" 
        	style="position:relative; left: -1%; bottom:-2px;" alt="">
        	잠깐! {{ resInfo.spsl_amt }}원 더 받아가세요! </div>
		    <div class="inspection-title" style= "font-size: 14px; line-height: 20px; font-weight: 600;">지금 판매하시는 중고폰은</div>
		    <span class="inspection-title" style= "font-size: 14px; line-height: 20px; font-weight: 700;">[민팃 All 보상]</span>
		    <span class="inspection-title" style= "font-size: 14px; line-height: 20px; font-weight: 600;"> 대상 모델입니다</span>
		    <div class="inspection-title" style= "font-size: 14px; line-height: 20px; font-weight: 600;">&nbsp;</div>
		    <div class="inspection-title" style= "font-size: 14px; line-height: 20px; font-weight: 600;">판매 완료 후 다음페이지에서</div>
		    <span class="inspection-title" style= "font-size: 14px; line-height: 20px; font-weight: 700;">[All 보상 신청하기]</span>
		    <span class="inspection-title" style= "font-size: 14px; line-height: 20px; font-weight: 600;">를 진행해 주세요!</span>
		    <div class="inspection-title" style= "font-size: 14px; line-height: 20px; font-weight: 600;">&nbsp;</div>
		    <div class="inspection-title" style= "font-size: 12px; line-height: 20px; font-weight: 600;">(이벤트 신청기한 : ~ 10/26까지)</div>
    </article>

    <figure class="inspection-image" v-if="!noAiImg">
      <h4 class="inspection-title">진단 상태</h4>
      <div class="img-box">
        <img
          :src="resInfo.ai_result_image_path"
          alt=""
          @load="handleImageOnLoad"
          @error="handleImagePathError">
      </div>
      <div class="img-box" v-if="resInfo.ai_result_image_path2">
        <img
          :src="resInfo.ai_result_image_path2"
          alt=""
          @load="handleImageOnLoad"
          @error="handleImagePathError">
      </div>
      <article class="inspection-list__result" style = "border: 1px solid #FFFFFF; padding: 0px;" >
      	<dl class="inspection-list__result-list" style = "border-bottom: 1px solid #D5D5D5;" v-for="item in resInfo.discount_list">
         <dt style="position:relative; left:10px; font-weight:700; color:#333333;">{{ item.type }}</dt> 
         <dd style="position:relative; right:10px; font-weight:400; color:#5F5F5F;">{{ item.code_name }}</dd> 
        </dl>
        <dl class="inspection-list__result-list">
         <dt style="position:relative; left:10px; font-weight:700; color:#333333;">{{ resInfo.discount_last.type }}</dt> 
         <dd style="position:relative; right:10px; font-weight:400; color:#5F5F5F;">{{ resInfo.discount_last.code_name }}</dd> 
        </dl>
      </article>
      <!-- <div class="img-box">
        <img src="@/assets/images/test_img.png" alt="">
        <p>얼룩 현상</p>
      </div> -->
    </figure>
    
     <figure class="inspection-image" v-if="resInfo.rsn_ctt != ''">
	      <h4 class="inspection-title">진단 상태</h4>
	      <dl class="inspection-list__result-list">
	        <dt style="width:360px;">{{ resInfo.rsn_ctt }}</dt>
	      </dl>    
    </figure>

    <article class="inspection-list__result" style="margin-top:15px; margin-bottom:18px;">
      <h4 class="inspection-title">진단 결과</h4>
      <dl class="inspection-list__result-list">
        <dt v-if="resInfo.rsn_ctt == ''">모델명</dt>
        <dd v-if="resInfo.rsn_ctt == ''">{{ resInfo.ptnm_nm }}</dd>
        <dt>접수일자</dt>
        <dd>{{ resInfo.reg_dt }}</dd>
        <dt>접수번호</dt>
        <dd>{{ resInfo.ord_number }}</dd>
        <dt>진단방식</dt>
        <dd v-if="resInfo.rsn_ctt == ''">AI 상세 진단</dd>
        <dd v-if="resInfo.rsn_ctt != ''">일반 진단</dd>
      </dl>
    </article>
    
    <div v-if="resInfo.rsn_ctt != ''" style="font-family: 'SUIT'; font-weight:400; font-size: 12.14px; line-height: 17.34px; margin-left:8px; margin-bottom:18px; color:#5F5F5F;">
    	※ 폐휴대폰은 데이터 삭제 인증서 발급 대상이 아니며, 안전하게<br>&nbsp;&nbsp;&nbsp;&nbsp; 파쇄·폐기됩니다
    </div>
    
    <div v-if="!isRegDone" id="regBtnDiv" class="ui-buttons">
      <ul class="ui-buttons__list">
        <li class="ui-buttons__item">
          <button
            type="button"
            class="ui-button ui-basic-button"
            @click="handleButtnClick('S')"
          >
            판매할게요
          </button>
          <br/>
          <button
            type="button"
            class="ui-button ui-gray-button"
            @click="handleButtnClick('C')"
          >
            취소
          </button>
        </li>
      </ul>
    </div>
    <div v-else id="regBtnDiv" class="ui-buttons">
      <ul class="ui-buttons__list">
        <li class="ui-buttons__item">
          <button
            type="button"
            class="ui-button ui-basic-button"
            @click="handleButtnClick('D')"
          >
            확인
          </button>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>

export default {
  name: 'ResultInfo',
  props: ['resInfo', 'noAiImg', 'isRegDone'],
  data: () => ({
  }),
  watch: {
  },
  created () {
  },
  methods: {
    handleImageOnLoad (e) {
      URL.revokeObjectURL(e.target.src)
    },
    handleImagePathError (e) {
      e.target.src = require(`@/assets/images/test_img.png`)
    },

    handleButtnClick(e){
      this.$emit('changeDntnInfo', e);
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/home/components/ResultInfo.vue